
<template>
  <div id="surveyjsEditorContainer" />
</template>

<script>
import "survey-core/defaultV2.min.css";
import "survey-creator-core/survey-creator-core.min.css";

import { mapState } from "vuex";

const creatorOptions = {
  showJSONEditorTab: true,
  showLogicTab: true,
  showPropertyGrid: false,
  isAutoSave: true,
  showPagesToolbox: false,
  pageEditMode: "standard",
  haveCommercialLicense: true,
  questionTypes: [
    "text",
    "checkbox",
    "panel",
    "radiogroup",
    "boolean",
    "comment",
    "rating",
    "expression",
  ]
};

export default {
  name: "SurveyEditor",
  props: {
    msg: String
  },
  data() {
    return {
      modifyData: { logoError: null},
      creator: null
    }
  },
  computed: mapState({
    currentSurvey: state => state.surveyModule.currentSurvey
  }),
  mounted() {
    const template = this.currentSurvey.template ? this.currentSurvey.template : null;

    this.$store.commit("setCurrentSurveyUnsavedSurveyTemplate", template);

    const SurveyCreator = require('survey-creator-knockout');

    this.creator = new SurveyCreator.SurveyCreator(creatorOptions);

    this.creator.onModified.add(() => {
      this.$emit("modify", this.modifyData)
    });

    this.creator.onActiveTabChanging.add(() => {
      this.$emit("modify", this.modifyData)
    });

    this.creator.onActiveTabChanged.add(() => {
      this.$emit("modify", this.modifyData)
    });

    this.creator.onSelectedElementChanging.add(() => {
      this.$emit("modify", this.modifyData)
    });  
    
    this.creator.onPropertyChanged.add(() => {
      this.$emit("modify", this.modifyData)
    });

    this.creator.onSelectedElementChanged.add(() => {
      this.$emit("modify", this.modifyData)
    });

    this.creator.text = template;
    this.creator.saveSurveyFunc = () => {
      this.$store.dispatch("saveCurrentSurveyConfig", this.creator.text);
    };
    this.creator.render("surveyjsEditorContainer");
  },
  watch: {
    currentSurvey() {
      const template = this.currentSurvey.template ? this.currentSurvey.template : null;
      this.$store.commit("setCurrentSurveyUnsavedSurveyTemplate", template);
      this.creator.text = template;
      this.$forceUpdate();
    }
  }
};
</script>

<style scoped>
#surveyjsEditorContainer {
  height: 100vh;
  width: 100%;
}
::v-deep#surveyjsEditorContainer .svc-tab-designer .sd-container-modern.sd-container-modern--static {
  max-width: 90% !important;
}
</style>
